// Generated by purs version 0.14.1
"use strict";
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Haskell_AST = require("../Haskell.AST/index.js");
var Record_Unsafe = require("../Record.Unsafe/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var UnsafePostParseRecord = function (unsafePostParseRecord) {
    this.unsafePostParseRecord = unsafePostParseRecord;
};
var PostParse = function (postParse) {
    this.postParse = postParse;
};
var unsafePostParseRecordNil = new UnsafePostParseRecord(function (v) {
    return function (x) {
        return x;
    };
});
var unsafePostParseRecord = function (dict) {
    return dict.unsafePostParseRecord;
};
var requiresBlockArguments = function (s) {
    return function (e) {
        var i = {
            tag: Haskell_AST.ExtensionUsed.value,
            msg: s + ";\x0arequires BlockArguments"
        };
        return new Haskell_AST.ExpInfo(i, e);
    };
};
var postParseV = new PostParse(function (x) {
    return x;
});
var postParseTyV = new PostParse(function (x) {
    return x;
});
var postParseToken = new PostParse(function (t) {
    return t;
});
var postParseRecord = function (dictRowToList) {
    return function (dictUnsafePostParseRecord) {
        return new PostParse(unsafePostParseRecord(dictUnsafePostParseRecord)(Type_Proxy["Proxy"].value));
    };
};
var postParseOp = new PostParse(function (x) {
    return x;
});
var postParseNoArguments = new PostParse(function (v) {
    return Data_Generic_Rep.NoArguments.value;
});
var postParseInfo = new PostParse(function (i) {
    return i;
});
var postParseId = new PostParse(function (x) {
    return x;
});
var postParseC = new PostParse(function (x) {
    return x;
});
var postParse = function (dict) {
    return dict.postParse;
};
var postParseArgument = function (dictPostParse) {
    return new PostParse(function (v) {
        return postParse(dictPostParse)(v);
    });
};
var postParseArray = function (dictPostParse) {
    return new PostParse(Data_Functor.map(Data_Functor.functorArray)(postParse(dictPostParse)));
};
var postParseConstructor = function (dictPostParse) {
    return new PostParse(function (v) {
        return postParse(dictPostParse)(v);
    });
};
var postParseEither = function (dictPostParse) {
    return function (dictPostParse1) {
        return new PostParse(Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither)(postParse(dictPostParse))(postParse(dictPostParse1)));
    };
};
var postParseMaybe = function (dictPostParse) {
    return new PostParse(Data_Functor.map(Data_Maybe.functorMaybe)(postParse(dictPostParse)));
};
var postParseNonEmptyArray = function (dictPostParse) {
    return new PostParse(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(postParse(dictPostParse)));
};
var postParseProduct = function (dictPostParse) {
    return function (dictPostParse1) {
        return new PostParse(function (v) {
            return new Data_Generic_Rep.Product(postParse(dictPostParse)(v.value0), postParse(dictPostParse1)(v.value1));
        });
    };
};
var postParseSum = function (dictPostParse) {
    return function (dictPostParse1) {
        return new PostParse(function (v) {
            if (v instanceof Data_Generic_Rep.Inl) {
                return new Data_Generic_Rep.Inl(postParse(dictPostParse)(v.value0));
            };
            if (v instanceof Data_Generic_Rep.Inr) {
                return new Data_Generic_Rep.Inr(postParse(dictPostParse1)(v.value0));
            };
            throw new Error("Failed pattern match at Haskell.PostParser (line 254, column 1 - line 256, column 40): " + [ v.constructor.name ]);
        });
    };
};
var postParseTuple = function (dictPostParse) {
    return function (dictPostParse1) {
        return new PostParse(Data_Bifunctor.bimap(Data_Bifunctor.bifunctorTuple)(postParse(dictPostParse))(postParse(dictPostParse1)));
    };
};
var unsafePostParseRecordCons = function (dictUnsafePostParseRecord) {
    return function (dictIsSymbol) {
        return function (dictPostParse) {
            return new UnsafePostParseRecord(function (v) {
                return function (x) {
                    var key = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                    var y = Record_Unsafe.unsafeGet(key)(x);
                    return Record_Unsafe.unsafeSet(key)(postParse(dictPostParse)(y))(unsafePostParseRecord(dictUnsafePostParseRecord)(Type_Proxy["Proxy"].value)(x));
                };
            });
        };
    };
};
var genericPostParse = function (dictGeneric) {
    return function (dictPostParse) {
        return function (x) {
            return Data_Generic_Rep.to(dictGeneric)(postParse(dictPostParse)(Data_Generic_Rep.from(dictGeneric)(x)));
        };
    };
};
var postParseField = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericField)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rhs";
    }))(dictPostParse))(new Data_Symbol.IsSymbol(function () {
        return "field";
    }))(postParseV))(new Data_Symbol.IsSymbol(function () {
        return "eq_";
    }))(postParseToken))))));
};
var postParseGCon = new PostParse(genericPostParse(Haskell_AST.genericGCon)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "commas_";
}))(postParseArray(postParseToken)))(new Data_Symbol.IsSymbol(function () {
    return "comma_";
}))(postParseToken)))))(postParseConstructor(postParseArgument(postParseC)))))));
var postParseGTyCon = new PostParse(function (t) {
    return genericPostParse(Haskell_AST.genericGTyCon)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "commas_";
    }))(postParseArray(postParseToken)))(new Data_Symbol.IsSymbol(function () {
        return "comma_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "arr_";
    }))(postParseToken)))))(postParseConstructor(postParseArgument(postParseC)))))))(t);
});
var postParseImportItem = new PostParse(genericPostParse(Haskell_AST.genericExportItem)(postParseSum(postParseConstructor(postParseArgument(postParseC)))(postParseConstructor(postParseArgument(postParseV)))));
var postParseLiteral = new PostParse(genericPostParse(Haskell_AST.genericLiteral)(postParseConstructor(postParseArgument(postParseToken))));
var postParseParens = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericParens)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "value";
    }))(dictPostParse))(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))))));
};
var postParseSepList = function (dictPostParse) {
    return new PostParse(function (x) {
        return genericPostParse(Haskell_AST.genericSepList)(postParseSum(postParseConstructor(postParseNoArguments))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
            return "tail";
        }))(postParseSepList(dictPostParse)))(new Data_Symbol.IsSymbol(function () {
            return "sep_";
        }))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
            return "head";
        }))(dictPostParse))))))(x);
    });
};
var postParseDeriving = new PostParse(genericPostParse(Haskell_AST.genericDeriving)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "deriving_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "dclasses";
}))(postParseEither(postParseToken)(postParseParens(postParseSepList(postParseToken)))))))));
var postParseImport = new PostParse(genericPostParse(Haskell_AST.genericImport)(postParseSum(postParseConstructor(postParseArgument(postParseV)))(postParseSum(postParseConstructor(postParseArgument(postParseC)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "items";
}))(postParseSepList(postParseImportItem)))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC)))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "dotdot_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC)))))))));
var postParseExport = new PostParse(genericPostParse(Haskell_AST.genericExport)(postParseSum(postParseConstructor(postParseArgument(postParseImport)))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "module_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "modid";
}))(postParseToken)))))));
var postParseExports = new PostParse(genericPostParse(Haskell_AST.genericExports)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "exports";
}))(postParseSepList(postParseExport)))(new Data_Symbol.IsSymbol(function () {
    return "comma_";
}))(postParseMaybe(postParseToken)))))));
var postParseModuleHeader = new PostParse(genericPostParse(Haskell_AST.genericModuleHeader)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "module_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "modid";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "exports";
}))(postParseMaybe(postParseExports)))))));
var postParseImpSpec = new PostParse(genericPostParse(Haskell_AST.genericImpSpec)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "imports";
}))(postParseSepList(postParseImport)))(new Data_Symbol.IsSymbol(function () {
    return "hiding_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "comma_";
}))(postParseMaybe(postParseToken))))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "imports";
}))(postParseSepList(postParseImport)))(new Data_Symbol.IsSymbol(function () {
    return "comma_";
}))(postParseMaybe(postParseToken))))))));
var postParseImpDecl = new PostParse(genericPostParse(Haskell_AST.genericImpDecl)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "qualified_";
}))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
    return "modid";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "impspec";
}))(postParseMaybe(postParseImpSpec)))(new Data_Symbol.IsSymbol(function () {
    return "import_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "as_";
}))(postParseMaybe(postParseTuple(postParseToken)(postParseToken))))))));
var postParseImpDecls = new PostParse(genericPostParse(Haskell_AST.genericImpDecls)(postParseConstructor(postParseArgument(postParseSepList(postParseImpDecl)))));
var postParsePat = new PostParse(function (p) {
    return genericPostParse(Haskell_AST.genericPat)(postParseSum(postParseConstructor(postParseArgument(postParseV)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "v";
    }))(postParseV))(new Data_Symbol.IsSymbol(function () {
        return "p";
    }))(postParsePat))(new Data_Symbol.IsSymbol(function () {
        return "as_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseGCon)))(postParseSum(postParseConstructor(postParseArgument(postParseLiteral)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "number";
    }))(postParseLiteral))(new Data_Symbol.IsSymbol(function () {
        return "minus_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseToken)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "tilde_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "p";
    }))(postParsePat)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "p";
    }))(postParsePat))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "ps";
    }))(postParseSepList(postParsePat)))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "ps";
    }))(postParseSepList(postParsePat)))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "p2";
    }))(postParsePat))(new Data_Symbol.IsSymbol(function () {
        return "p1";
    }))(postParsePat))(new Data_Symbol.IsSymbol(function () {
        return "op";
    }))(postParseC)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "c";
    }))(postParseGCon))(new Data_Symbol.IsSymbol(function () {
        return "args";
    }))(postParseArray(postParsePat))))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "fields";
    }))(postParseSepList(postParseField(postParsePat))))(new Data_Symbol.IsSymbol(function () {
        return "c";
    }))(postParseC)))))))))))))))))(p);
});
var postParseFunLhs = new PostParse(function (x) {
    return genericPostParse(Haskell_AST.genericFunLhs)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "v";
    }))(postParseV))(new Data_Symbol.IsSymbol(function () {
        return "args";
    }))(postParseNonEmptyArray(postParsePat))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "op";
    }))(postParseV))(new Data_Symbol.IsSymbol(function () {
        return "arg2";
    }))(postParsePat))(new Data_Symbol.IsSymbol(function () {
        return "arg1";
    }))(postParsePat)))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lhs";
    }))(postParseFunLhs))(new Data_Symbol.IsSymbol(function () {
        return "args";
    }))(postParseNonEmptyArray(postParsePat))))))))(x);
});
var postParseLhs_ = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericLhs_)(postParseSum(postParseConstructor(postParseArgument(postParseFunLhs)))(postParseConstructor(postParseArgument(dictPostParse)))));
};
var postParseSimpleTy = new PostParse(genericPostParse(Haskell_AST.genericSimpleTy)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "args";
}))(postParseArray(postParseTyV)))))));
var postParseTy = new PostParse(function (t) {
    return genericPostParse(Haskell_AST.genericTy)(postParseSum(postParseConstructor(postParseArgument(postParseTyV)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "f";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "args";
    }))(postParseNonEmptyArray(postParseTy))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "t";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "t2";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "t1";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "arr_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "ts";
    }))(postParseSepList(postParseTy)))(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "t";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken)))))(postParseConstructor(postParseArgument(postParseGTyCon)))))))))(t);
});
var postParseBangTy = new PostParse(genericPostParse(Haskell_AST.genericBangTy)(postParseSum(postParseConstructor(postParseArgument(postParseTy)))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "t";
}))(postParseTy))(new Data_Symbol.IsSymbol(function () {
    return "bang_";
}))(postParseToken)))))));
var postParseFieldDecl = new PostParse(genericPostParse(Haskell_AST.genericFieldDecl)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "t";
}))(postParseBangTy))(new Data_Symbol.IsSymbol(function () {
    return "field";
}))(postParseV))(new Data_Symbol.IsSymbol(function () {
    return "colons_";
}))(postParseToken))))));
var postParseFieldDecls = new PostParse(genericPostParse(Haskell_AST.genericFieldDecls)(postParseConstructor(postParseArgument(postParseSepList(postParseFieldDecl)))));
var postParseConstr = new PostParse(genericPostParse(Haskell_AST.genericConstr)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "ts";
}))(postParseArray(postParseBangTy)))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "t2";
}))(postParseBangTy))(new Data_Symbol.IsSymbol(function () {
    return "t1";
}))(postParseBangTy))(new Data_Symbol.IsSymbol(function () {
    return "op";
}))(postParseC)))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "fields";
}))(postParseFieldDecls))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC))))))));
var postParseConstrs = new PostParse(genericPostParse(Haskell_AST.genericConstrs)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "eq_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "constrs";
}))(postParseSepList(postParseConstr)))))));
var postParseGenDecl = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericGenDecl)(postParseSum(postParseConstructor(postParseArgument(dictPostParse)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "vars";
    }))(postParseSepList(postParseV)))(new Data_Symbol.IsSymbol(function () {
        return "t";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "colons_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "ops";
    }))(postParseSepList(postParseOp)))(new Data_Symbol.IsSymbol(function () {
        return "level";
    }))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
        return "fixity";
    }))(postParseToken)))))(postParseConstructor(postParseNoArguments))))));
};
var postParseNewconstr = new PostParse(genericPostParse(Haskell_AST.genericNewconstr)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "t";
}))(postParseTy))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC)))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "t";
}))(postParseTy))(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "field";
}))(postParseV))(new Data_Symbol.IsSymbol(function () {
    return "colons_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "c";
}))(postParseC)))))));
var postParseWhere = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericWhere)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "where_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "decls";
    }))(dictPostParse))))));
};
var postParseExp = new PostParse(function (v) {
    if (v instanceof Haskell_AST.App) {
        return new Haskell_AST.App({
            f: (function () {
                if (v.value0.f instanceof Haskell_AST.Do) {
                    return requiresBlockArguments("Naked 'do' block applied as a function")(postParse(postParseExp)(v.value0.f));
                };
                if (v.value0.f instanceof Haskell_AST.Case) {
                    return requiresBlockArguments("Naked 'case' block applied as a function")(postParse(postParseExp)(v.value0.f));
                };
                return postParse(postParseExp)(v.value0.f);
            })(),
            args: Data_Functor.mapFlipped(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(v.value0.args)(function (arg) {
                if (arg instanceof Haskell_AST.Do) {
                    return requiresBlockArguments("Naked 'do' in argument position")(postParse(postParseExp)(arg));
                };
                if (arg instanceof Haskell_AST.Case) {
                    return requiresBlockArguments("Naked 'case' in argument position")(postParse(postParseExp)(arg));
                };
                if (arg instanceof Haskell_AST.Let) {
                    return requiresBlockArguments("Naked 'let' in argument position")(postParse(postParseExp)(arg));
                };
                if (arg instanceof Haskell_AST.Fun) {
                    return requiresBlockArguments("Naked '\\' in argument position")(postParse(postParseExp)(arg));
                };
                return postParse(postParseExp)(arg);
            })
        });
    };
    return genericPostParse(Haskell_AST.genericExp)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "then_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "sc2_";
    }))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
        return "sc1_";
    }))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
        return "if_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "else_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e3";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "e2";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "e1";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "v";
    }))(postParseV))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "bs_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "arr_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "let_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "in_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "decls";
    }))(postParseDecls)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "stmts";
    }))(postParseSepList(postParseStmt)))(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "do_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "of_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "case_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "alts";
    }))(postParseSepList(postParseAlt))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "fields";
    }))(postParseSepList(postParseField(postParseExp))))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "op";
    }))(postParseOp))(new Data_Symbol.IsSymbol(function () {
        return "e2";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "e1";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "op";
    }))(postParseOp))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "op";
    }))(postParseOp))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "f";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "args";
    }))(postParseNonEmptyArray(postParseExp))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "minus_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "t";
    }))(postParseTy))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "colons_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "es";
    }))(postParseSepList(postParseExp))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "to";
    }))(postParseMaybe(postParseExp)))(new Data_Symbol.IsSymbol(function () {
        return "then_";
    }))(postParseMaybe(postParseTuple(postParseToken)(postParseExp))))(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "from";
    }))(postParseExp))(new Data_Symbol.IsSymbol(function () {
        return "dotdot_";
    }))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "vbar_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "rb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "quals";
    }))(postParseSepList(postParseQual)))(new Data_Symbol.IsSymbol(function () {
        return "lb_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "e";
    }))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "rp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "lp_";
    }))(postParseToken))(new Data_Symbol.IsSymbol(function () {
        return "es";
    }))(postParseSepList(postParseExp))))))(postParseSum(postParseConstructor(postParseArgument(postParseV)))(postParseSum(postParseConstructor(postParseArgument(postParseLiteral)))(postParseSum(postParseConstructor(postParseArgument(postParseGCon)))(postParseConstructor(postParseProduct(postParseArgument(postParseInfo))(postParseArgument(postParseExp))))))))))))))))))))))))(v);
});
var postParseDecl = new PostParse(function (x) {
    return genericPostParse(Haskell_AST.genericDecl)(postParseConstructor(postParseArgument(postParseGenDecl(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "where_";
    }))(postParseMaybe(postParseWhere(postParseDecls))))(new Data_Symbol.IsSymbol(function () {
        return "rhs";
    }))(postParseRhs))(new Data_Symbol.IsSymbol(function () {
        return "lhs";
    }))(postParseLhs_(postParsePat)))))))(x);
});
var postParseDecls = new PostParse(genericPostParse(Haskell_AST.genericDecls)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "decls";
}))(postParseSepList(postParseDecl)))))));
var postParseGuard = new PostParse(genericPostParse(Haskell_AST.genericGuard)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "p";
}))(postParsePat))(new Data_Symbol.IsSymbol(function () {
    return "leftarr_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "e";
}))(postParseExp)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "let_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "decls";
}))(postParseDecls)))))(postParseConstructor(postParseArgument(postParseExp))))));
var postParseGuards = new PostParse(genericPostParse(Haskell_AST.genericGuards)(postParseConstructor(postParseArgument(postParseSepList(postParseGuard)))));
var postParseGdPat = new PostParse(genericPostParse(Haskell_AST.genericGdPat)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "vbar_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "guards";
}))(postParseGuards))(new Data_Symbol.IsSymbol(function () {
    return "e";
}))(postParseExp))(new Data_Symbol.IsSymbol(function () {
    return "arr_";
}))(postParseToken))))));
var postParseGdRhs = new PostParse(genericPostParse(Haskell_AST.genericGdRhs)(postParseConstructor(postParseArgument(postParseGdPat))));
var postParseRhs = new PostParse(genericPostParse(Haskell_AST.genericRhs)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "eq_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "e";
}))(postParseExp)))))(postParseConstructor(postParseArgument(postParseNonEmptyArray(postParseGdRhs))))));
var postParseQual = new PostParse(genericPostParse(Haskell_AST.genericQual)(postParseConstructor(postParseArgument(postParseGuard))));
var postParseStmt = new PostParse(genericPostParse(Haskell_AST.genericStmt)(postParseSum(postParseConstructor(postParseNoArguments))(postParseConstructor(postParseArgument(postParseGuard)))));
var postParseAlt = new PostParse(genericPostParse(Haskell_AST.genericAlt)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseDecls))))(new Data_Symbol.IsSymbol(function () {
    return "p";
}))(postParsePat))(new Data_Symbol.IsSymbol(function () {
    return "e";
}))(postParseExp))(new Data_Symbol.IsSymbol(function () {
    return "arr_";
}))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseDecls))))(new Data_Symbol.IsSymbol(function () {
    return "p";
}))(postParsePat))(new Data_Symbol.IsSymbol(function () {
    return "gdpats";
}))(postParseNonEmptyArray(postParseGdPat))))))(postParseConstructor(postParseNoArguments)))));
var postParseCDecl = new PostParse(genericPostParse(Haskell_AST.genericCDecl)(postParseConstructor(postParseArgument(postParseGenDecl(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseDecls))))(new Data_Symbol.IsSymbol(function () {
    return "rhs";
}))(postParseRhs))(new Data_Symbol.IsSymbol(function () {
    return "lhs";
}))(postParseLhs_(postParseV))))))));
var postParseCDecls = new PostParse(genericPostParse(Haskell_AST.genericCDecls)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "decls";
}))(postParseSepList(postParseCDecl)))))));
var postParseIDecl = new PostParse(genericPostParse(Haskell_AST.genericIDecl)(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseDecls))))(new Data_Symbol.IsSymbol(function () {
    return "rhs";
}))(postParseRhs))(new Data_Symbol.IsSymbol(function () {
    return "lhs";
}))(postParseLhs_(postParseV))))))(postParseConstructor(postParseNoArguments))));
var postParseIDecls = new PostParse(genericPostParse(Haskell_AST.genericIDecls)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "decls";
}))(postParseSepList(postParseIDecl)))))));
var postParseTopDecl = new PostParse(genericPostParse(Haskell_AST.genericTopDecl)(postParseSum(postParseConstructor(postParseArgument(postParseDecl)))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "type_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "t";
}))(postParseTy))(new Data_Symbol.IsSymbol(function () {
    return "stype";
}))(postParseSimpleTy))(new Data_Symbol.IsSymbol(function () {
    return "eq_";
}))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "stype";
}))(postParseSimpleTy))(new Data_Symbol.IsSymbol(function () {
    return "deriving";
}))(postParseMaybe(postParseDeriving)))(new Data_Symbol.IsSymbol(function () {
    return "data_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "constrs";
}))(postParseMaybe(postParseConstrs))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "stype";
}))(postParseSimpleTy))(new Data_Symbol.IsSymbol(function () {
    return "newtype_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "newconstr";
}))(postParseNewconstr))(new Data_Symbol.IsSymbol(function () {
    return "eq_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "deriving";
}))(postParseMaybe(postParseDeriving))))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseCDecls))))(new Data_Symbol.IsSymbol(function () {
    return "tycls";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "class_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "arg";
}))(postParseToken)))))(postParseSum(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "where_";
}))(postParseMaybe(postParseWhere(postParseIDecls))))(new Data_Symbol.IsSymbol(function () {
    return "qtycls";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "instance_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "arg";
}))(postParseTy)))))(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "ts";
}))(postParseSepList(postParseTy)))(new Data_Symbol.IsSymbol(function () {
    return "rp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lp_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "default_";
}))(postParseToken))))))))))));
var postParseTopDecls = new PostParse(genericPostParse(Haskell_AST.genericTopDecls)(postParseConstructor(postParseArgument(postParseSepList(postParseTopDecl)))));
var postParseModuleBody = new PostParse(genericPostParse(Haskell_AST.genericModuleBody)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "topdecls";
}))(postParseTopDecls))(new Data_Symbol.IsSymbol(function () {
    return "sc_";
}))(postParseMaybe(postParseToken)))(new Data_Symbol.IsSymbol(function () {
    return "rb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "lb_";
}))(postParseToken))(new Data_Symbol.IsSymbol(function () {
    return "impdecls";
}))(postParseImpDecls))))));
var postParseModule = new PostParse(genericPostParse(Haskell_AST.genericModule)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
    return "header";
}))(postParseMaybe(postParseModuleHeader)))(new Data_Symbol.IsSymbol(function () {
    return "body";
}))(postParseModuleBody))))));
var postParseWhole = function (dictPostParse) {
    return new PostParse(genericPostParse(Haskell_AST.genericWhole)(postParseConstructor(postParseArgument(postParseRecord()(unsafePostParseRecordCons(unsafePostParseRecordCons(unsafePostParseRecordNil)(new Data_Symbol.IsSymbol(function () {
        return "value";
    }))(dictPostParse))(new Data_Symbol.IsSymbol(function () {
        return "eof";
    }))(postParseToken))))));
};
module.exports = {
    postParse: postParse,
    unsafePostParseRecord: unsafePostParseRecord,
    PostParse: PostParse,
    requiresBlockArguments: requiresBlockArguments,
    UnsafePostParseRecord: UnsafePostParseRecord,
    genericPostParse: genericPostParse,
    postParseModule: postParseModule,
    postParseModuleHeader: postParseModuleHeader,
    postParseExports: postParseExports,
    postParseExport: postParseExport,
    postParseImport: postParseImport,
    postParseImportItem: postParseImportItem,
    postParseModuleBody: postParseModuleBody,
    postParseImpDecls: postParseImpDecls,
    postParseImpDecl: postParseImpDecl,
    postParseImpSpec: postParseImpSpec,
    postParseTopDecls: postParseTopDecls,
    postParseTopDecl: postParseTopDecl,
    postParseConstrs: postParseConstrs,
    postParseConstr: postParseConstr,
    postParseNewconstr: postParseNewconstr,
    postParseBangTy: postParseBangTy,
    postParseFieldDecls: postParseFieldDecls,
    postParseFieldDecl: postParseFieldDecl,
    postParseCDecls: postParseCDecls,
    postParseCDecl: postParseCDecl,
    postParseIDecls: postParseIDecls,
    postParseIDecl: postParseIDecl,
    postParseSimpleTy: postParseSimpleTy,
    postParseDeriving: postParseDeriving,
    postParseDecls: postParseDecls,
    postParseDecl: postParseDecl,
    postParseGenDecl: postParseGenDecl,
    postParseLhs_: postParseLhs_,
    postParseFunLhs: postParseFunLhs,
    postParseRhs: postParseRhs,
    postParseGdRhs: postParseGdRhs,
    postParseGdPat: postParseGdPat,
    postParseGuards: postParseGuards,
    postParseGuard: postParseGuard,
    postParseWhole: postParseWhole,
    postParseSepList: postParseSepList,
    postParseWhere: postParseWhere,
    postParseParens: postParseParens,
    postParseTyV: postParseTyV,
    postParseV: postParseV,
    postParseC: postParseC,
    postParseId: postParseId,
    postParseOp: postParseOp,
    postParseToken: postParseToken,
    postParseMaybe: postParseMaybe,
    postParseEither: postParseEither,
    postParseTuple: postParseTuple,
    postParseNonEmptyArray: postParseNonEmptyArray,
    postParseArray: postParseArray,
    postParseExp: postParseExp,
    postParseStmt: postParseStmt,
    postParseAlt: postParseAlt,
    postParseField: postParseField,
    postParseQual: postParseQual,
    postParseLiteral: postParseLiteral,
    postParseGCon: postParseGCon,
    postParsePat: postParsePat,
    postParseTy: postParseTy,
    postParseGTyCon: postParseGTyCon,
    postParseInfo: postParseInfo,
    postParseRecord: postParseRecord,
    unsafePostParseRecordNil: unsafePostParseRecordNil,
    unsafePostParseRecordCons: unsafePostParseRecordCons,
    postParseSum: postParseSum,
    postParseProduct: postParseProduct,
    postParseConstructor: postParseConstructor,
    postParseArgument: postParseArgument,
    postParseNoArguments: postParseNoArguments
};
